import withModal from '../../../../../../components/global/modal/withModal';
import AddressBookFilters from './AddressBookFilters';

export const ADDRESS_BOOK_FILTERS_MODAL = 'ADDRESS_BOOK_FILTERS_MODAL';

const AddressBookFiltersModal = withModal(AddressBookFilters, {
  name: ADDRESS_BOOK_FILTERS_MODAL,
  size: 'md',
  hideHeader: true,
  shouldCloseOnOverlayClick: true,
});

export default AddressBookFiltersModal;
